import React, { Component, PropTypes } from 'react'
import { fromJS } from 'immutable'
import AdminNavbar from '../../components/AdminNavbar'
import styled from 'styled-components'
import { searchCities } from '../../sources/SearchSource'
import { deleteCity } from '../../sources/AdminSource'
import { translate } from 'react-i18next'
import CardContainer from '../../components/CardContainer'
import Trash from '../../svg-icons/Trash'
import Input from '../../components/Input'
import ThemeContainer from '../../components/ThemeContainer'
import { Metrics, Fonts } from '../../Themes'
import ErrorModal from '../../components/Modal/ErrorModal'
import DialogModal from '../../components/Modal/DialogModal'

const CustomCardContainer = styled(CardContainer)`
  margin-top: ${Metrics.margins.base};
`

const Container = styled.div`
  overflow-y: scroll;
  max-height: ${Metrics.components.adminContent};
`

const List = styled.div`margin-top: ${Metrics.margins.base};`

const Name = styled.div`${Fonts.style.Label};`

const ThrashContainer = styled.div`
  position: absolute;
  right: 0;
  top: ${Metrics.margins.base};
`

const City = styled.div`
  border-bottom: ${Metrics.borders.default};
  height: 50px;
  cursor: pointer;
  padding: 18px 0;
  position: relative;
`

const SearchContainer = styled.div`
  border-bottom: ${Metrics.borders.defaultBorder};
  height: 50px;
`

const CustomThemeContainer = styled(ThemeContainer)`
  padding-left: ${Metrics.components.customThemeSpacing} !important;
  padding-right: ${Metrics.components.customThemeSpacing} !important;
`

class AdminPictures extends Component {
  constructor (props) {
    super(props)
    this.state = {
      cities: [],
      cityToDelete: null,
      name: '',
      modal: false
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.fetchCities = this.fetchCities.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { name, modal, cities, cityToDelete } = this.state
    if (
      name !== nextState.name ||
      modal !== nextState.modal ||
      !fromJS(nextState.cities).equals(fromJS(cities)) ||
      cityToDelete !== nextState.cityToDelete
    ) {
      return true
    }
    return false
  }

  componentWillMount () {
    this.fetchCities()
  }

  handleChange (event) {
    this.setState({ name: event.target.value }, () => {
      searchCities({
        where: {
          city: {
            startsWith: this.state.name
          }
        },
        sort: 'city ASC'
      })
        .then(response => this.setState({ cities: response.data }))
        .catch(error => console.log(error))
    })
  }

  fetchCities () {
    searchCities({ sort: 'city ASC' })
      .then(response => this.setState({ cities: response.data }))
      .catch(error => console.log(error))
  }

  handleDelete () {
    deleteCity(this.state.cityToDelete.id)
      .then(response => {
        this.setState({ modal: false, name: '' }, () => this.fetchCities())
      })
      .catch(error => {
        console.log(error)
        this.toggleModal('error')
      })
  }

  toggleModal (modal) {
    this.setState({ modal })
  }

  render () {
    const { t, admin, dropdownLinks, router } = this.props
    const { name, cities, modal } = this.state
    return (
      <div>
        <AdminNavbar
          admin={admin}
          fixedSearchBar
          dropdownLinks={dropdownLinks}
          rightSideActions={[
            {
              label: t('Create City'),
              secondary: true,
              onClick: () => router.push(`/admin/locations/cities/new`)
            }
          ]}
        />
        <ErrorModal
          visible={modal === 'error'}
          message={t('There was a problem when deleting a city')}
          closeAction={() => this.toggleModal(false)}
          header={t('Error')}
        />
        <DialogModal
          visible={modal === 'dialog'}
          message={t('Do you want to delete this city?')}
          closeAction={() => this.toggleModal(false)}
          buttons={{
            apply: { label: t('Delete'), onClick: this.handleDelete },
            cancel: {
              label: t('Cancel'),
              onClick: () => this.toggleModal(false)
            }
          }}
        />
        <Container>
          <CustomThemeContainer>
            <CustomCardContainer title={t('Cities')}>
              <SearchContainer>
                <Input
                  handleChange={this.handleChange}
                  value={name}
                  placeholder={t('Search for cities')}
                />
              </SearchContainer>
              <List>
                {cities &&
                  cities.length > 0 &&
                  cities.map((city, index) => {
                    return (
                      <City
                        key={`city-${city.city}-${index}`}
                        onClick={() =>
                          router.push(`/admin/locations/cities/${city.id}`)}>
                        <Name>{city.city}</Name>
                        <ThrashContainer>
                          <Trash
                            onClick={event => {
                              event.stopPropagation()
                              this.setState({
                                cityToDelete: city,
                                modal: 'dialog'
                              })
                            }}
                          />
                        </ThrashContainer>
                      </City>
                    )
                  })}
              </List>
            </CustomCardContainer>
          </CustomThemeContainer>
        </Container>
      </div>
    )
  }
}

AdminPictures.propTypes = {
  t: PropTypes.func,
  router: PropTypes.object,
  admin: PropTypes.object,
  dropdownLinks: PropTypes.array
}

export default translate([ 'common', 'admin' ], { wait: true })(AdminPictures)



// WEBPACK FOOTER //
// ./src/pages/AdminLocations/AdminCities.js